module.exports = __webpack_public_path__ + "0dd2bc850fef2d80b1892852b7aeb2ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/baywood.png
// module id = 1420
// module chunks = 0